import { useEffect } from 'react';

import { preloadGateway } from './validateCardWithGateway';

const IDLE_TIMEOUT_MS = 3000;
const FALLBACK_DELAY_MS = 1;

// The library is only needed when the user submits the card, so the download waits for the browser to be idle
// instead of competing with the first render of the page.
export const usePreloadGateway = (isCardFormVisible = true) => {
  useEffect(() => {
    if (!isCardFormVisible) return undefined;

    if (typeof window.requestIdleCallback === 'function') {
      const idleHandle = window.requestIdleCallback(preloadGateway, { timeout: IDLE_TIMEOUT_MS });
      return () => window.cancelIdleCallback?.(idleHandle);
    }

    const timerHandle = window.setTimeout(preloadGateway, FALLBACK_DELAY_MS);
    return () => window.clearTimeout(timerHandle);
  }, [isCardFormVisible]);
};
